import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GATrackingPdpOtherOffersClickEvent implements GATrackingEvent {
  constructor(private payload: any){}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PdpOtherOffersInteraction;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PdpOtherOffersInteraction,
      label: this.payload.label,
      gtmCustom: {
        category: this.payload.category,
        ...this.payload.seller && {seller: this.payload.seller }
      }
    };
  }
}
